export default __webpack_public_path__ + "static/logo-ranking-2021-full-0b83291d809a3e8508d964deb1b8d23b.svg";